import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IApproveCollectionTriageClipRequest } from './approve-collection-triage-clip-request';
import type { IApproveCollectionTriageClipResponse } from './approve-collection-triage-clip-response';
import { approveCollectionTriageClipResponseSchema } from './approve-collection-triage-clip-response';

export async function approveCollectionTriageClipApi({
  collectionId,
  clipId,
  verticalRejected,
}: IApproveCollectionTriageClipRequest): Promise<
  IValidatedResponse<IApproveCollectionTriageClipResponse>
> {
  return postRequest<IApproveCollectionTriageClipResponse>({
    path: `/sys/collections/${collectionId}/triage/clips/${clipId}/approve`,
    body: { verticalRejected: verticalRejected ?? false },
    schema: approveCollectionTriageClipResponseSchema,
  });
}
